import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import Moment from 'moment';
import { Popup } from 'components/Popup/popup';
import { formatTimezoneDateTime } from 'helper/unit-helper';

class SignoffMultiplePopup extends React.Component {
  static propTypes = {
    onSaveSignoffPopup: PropTypes.func,
    onCancelSignoffPopup: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      lastClosedDate: Moment().format('MM/DD/YYYY')
    };
  }

  toolTip = () => {
    return (
      <Tooltip id='breadcrumb_tooltip' className='in tooltip-siteone'>
        <span>This date is also assigned to Last resolved date of all the work orders with Open status.</span>
      </Tooltip>
    );
  }

  onChangeLastClosedDate = (lastClosedDate) => {
    if (typeof (lastClosedDate) === 'string') {
      this.setState({ lastClosedDate });
      if (Moment(lastClosedDate, 'MM/DD/YYYY', true).isValid() || lastClosedDate === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    } else {
      this.setState({ lastClosedDate: Moment(lastClosedDate).format('MM/DD/YYYY') });
      if (Moment(lastClosedDate, 'MM/DD/YYYY', true).isValid() || lastClosedDate === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    }
  }

  onSave = (e) => {
    e.preventDefault();
    const lastClosedDate = formatTimezoneDateTime(Moment(this.state.lastClosedDate));
    this.props.onSaveSignoffPopup(lastClosedDate);
  }

  render() {

    const disabled = !this.state.lastClosedDate || this.state.dateError;
    return (
      <Popup ref={(ref) => { this.signoffMultiple = ref; }} isHasFaded={true} className='close-multi-popup'>
        <div className='form-group' style={{ marginBottom: 0 }}>
          <div className='col-sm-12 col-xs-12' style={{padding: 0}}>
            <span
              className='col-xs-12'
              style={{ paddingLeft: 15, color: '#444', lineHeight: '40px' }}>
                Last closed
              <span className='text-danger'> *</span>
              <OverlayTrigger placement='top' overlay={this.toolTip()}>
                <i
                  className='fa fa-warning'
                  style={{
                    color: '#FFCA3A',
                    marginLeft: 15,
                    fontSize: 20,
                    verticalAlign: 'middle'
                  }} />
              </OverlayTrigger>
            </span>
            <div className='col-sm-10 col-xs-12'>
              <Datetime
                ref={ref => { this.lastClosedDate = ref; }}
                inputProps={{ placeholder: 'mm/dd/yyyy' }}
                value={this.state.lastClosedDate}
                timeFormat={false}
                onChange={lastClosedDate => this.onChangeLastClosedDate(lastClosedDate)}
                closeOnSelect={true}/>
              {this.state.dateError &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>
              }
            </div>
          </div>
        </div>
        <ul className='wo-popup-bottom-btn' style={{ marginTop: 0, borderTop: 0 }}>
          <li>
            <button
              className='btn btn-primary btn-siteone-default btn-wo-edit'
              onClick={this.props.onCancelSignoffPopup}>Cancel
            </button>
          </li>
          <li>
            <button
              className='btn btn-primary btn-siteone'
              onClick={this.onSave}
              disabled={disabled}>Save & Close
            </button>
          </li>
        </ul>
      </Popup>
    );
  }
}

export default SignoffMultiplePopup;



// WEBPACK FOOTER //
// ./src/Request-Services/Components/SignoffMultiplePopup.js